import {
  SimpleGrid,
  Text,
} from '@chakra-ui/react';
import { BsBookshelf, BsFillSendFill } from 'react-icons/bs';
import { useGetFormStatsQuery } from '../../Services/apiSlice';
import DashboardCard from './Card';

const Cards = () => {
  const { data: stats, isFetching } = useGetFormStatsQuery();

  return (
    <SimpleGrid columns={{ sm: 1, md: 2, xl: 4 }} spacing="24px" mb="20px">
      <DashboardCard
        isFetching={isFetching}
        title="Forms"
        value={stats?.currentFormsCount || 0}
        icon={BsBookshelf}
        helper={(
          <>
            You have
            {' '}
            {/* eslint-disable-next-line no-unsafe-optional-chaining */}
            <b>{(stats?.maxForms - stats?.currentFormsCount) || 0}</b>
            {' '}
            form left
          </>
        )}
      />
      <DashboardCard
        isFetching={isFetching}
        title="Total submissions"
        value={stats?.submissionsTotal || 0}
        icon={BsFillSendFill}
        helper={(
          <>
            <Text
              as="span"
              color={(stats?.submissionsPerMonth || 0) * 0.9 > (stats?.submissions || 0) ? 'green.400' : 'red.400'}
              fontWeight="bold"
            >
              {stats?.submissions || 0}
              {' '}
            </Text>
            on the current month
          </>
        )}
      />
    </SimpleGrid>
  );
};

export default Cards;
